// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  TtwHighlightV1,
  TtwKeyStatV1,
  SavedTtwPageRow,
} from "./types";

export const params = {
  brand: __t.option(__t.uuid()),
  featureImage: __t.string(),
  pitchVideoUrl: __t.option(__t.string()),
  pitchVideoUpload: __t.option(__t.string()),
  businessName: __t.string(),
  category: __t.string(),
  targetProperty: __t.option(__t.uuid()),
  showNominator: __t.bool(),
  showTotalReserved: __t.bool(),
  showAppreciationShare: __t.bool(),
  get highlights() {
    return __t.array(TtwHighlightV1);
  },
  stewardImage: __t.option(__t.string()),
  stewardQuote: __t.option(__t.string()),
  stewardAttribution: __t.option(__t.string()),
  stewardAbout: __t.option(__t.string()),
  get keyStats() {
    return __t.array(TtwKeyStatV1);
  },
  realEstateAbout: __t.option(__t.string()),
  targetArea: __t.option(__t.string()),
  gallery: __t.array(__t.string()),
  propertyType: __t.option(__t.string()),
  stories: __t.option(__t.string()),
  yearBuilt: __t.option(__t.string()),
  propertySqft: __t.option(__t.i32()),
  showEstimatedValueChart: __t.bool(),
  accessCode: __t.option(__t.string()),
  browsable: __t.bool(),
};
export const returnType = SavedTtwPageRow